import { render, staticRenderFns } from "./SpecialityChess.vue?vue&type=template&id=f3c558e8&scoped=true"
import script from "./SpecialityChess.vue?vue&type=script&lang=js"
export * from "./SpecialityChess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c558e8",
  null
  
)

export default component.exports